import { endpoint } from "./endpoints";
import {
  ACCOUNTANT_API,
  parseBody,
  getErrorMessage,
  extractArrayFromData,
  mapCsvLogRow,
} from "./driverLedgerCsv";

export const PAYMENT_CSV_EXPORT_KEY = "payment";

const formatPaymentCsvFilters = (filter) => {
  if (!filter || typeof filter !== "object") return "—";

  const search = String(filter.search ?? "").trim();
  const type = String(filter.type ?? "").trim();
  const fromDate = String(filter.from_date ?? filter.fromDate ?? "").trim();
  const toDate = String(filter.to_date ?? filter.toDate ?? "").trim();
  const parts = [];

  if (type) parts.push(`Transition Type: ${type}`);
  if (search) parts.push(`Search: ${search}`);
  if (fromDate && toDate) parts.push(`Date: ${fromDate} to ${toDate}`);

  return parts.length > 0 ? parts.join(" | ") : "—";
};

export const requestPaymentHistoryCsvExport = async ({
  search = "",
  fromDate,
  toDate,
  type,
  token,
}) => {
  const params = new URLSearchParams({
    search: String(search ?? "").trim(),
  });
  if (fromDate && toDate) {
    params.set("from_date", fromDate);
    params.set("to_date", toDate);
  }
  if (type && String(type).trim()) {
    params.set("type", String(type).trim());
  }

  const url = `${ACCOUNTANT_API}${endpoint.getPaymentHistoryCSV}?${params.toString()}`;
  const response = await fetch(url, {
    method: "GET",
    headers: { Authorization: `Bearer ${token}` },
  });
  const payload = await parseBody(response);

  if (!response.ok) {
    throw new Error(getErrorMessage(payload, response));
  }

  const apiCode = payload?.code;
  if (apiCode != null && apiCode !== 200 && apiCode !== 201) {
    throw new Error(getErrorMessage(payload, response));
  }

  return payload;
};

export const fetchPaymentCsvLog = async (token) => {
  const url = `${ACCOUNTANT_API}${endpoint.getPaymentCsvLog}`;
  const response = await fetch(url, {
    method: "GET",
    headers: { Authorization: `Bearer ${token}` },
  });
  const payload = await parseBody(response);

  if (!response.ok) {
    throw new Error(getErrorMessage(payload, response));
  }

  const apiCode = payload?.code;
  if (apiCode != null && apiCode !== 200 && apiCode !== 201) {
    throw new Error(getErrorMessage(payload, response));
  }

  const raw = Array.isArray(payload)
    ? payload
    : extractArrayFromData(payload?.data, [
        "payment_csv_log_data",
        "payment_history_csv_log_data",
        "csv_log_data",
        "report_data",
        "csv_logs",
        "logs",
        "data",
        "list",
      ]);

  return raw.map((item, index) => ({
    ...mapCsvLogRow(item, index),
    filters: formatPaymentCsvFilters(item?.filter),
  }));
};
